<div class="card">
  <div class="card-body" style="overflow-x: auto;">
    <app-tab-panel [displayMode]="tabPanelDisplayMode.horizontal">
      @if (showWorkflowTaskHistoryTab) {
      <app-tab [title]="'Workflow Task History'">
        <app-components-managecustomer-workflowtaskhistory *tabContent [customer]="customer">
        </app-components-managecustomer-workflowtaskhistory>
      </app-tab>
      }
      <app-tab [title]="'Completed Task History'">
        <app-components-managecustomer-completedtasks *tabContent [customer]="customer">
        </app-components-managecustomer-completedtasks>
      </app-tab>
      @if (canViewPendingWork) {
      <app-tab [title]="'View Pending Tasks'">
        <app-components-managecustomer-pendingwork *tabContent [customerId]="customer.CustomerId">
        </app-components-managecustomer-pendingwork>
      </app-tab>
      }
      <app-dynamic-tab [title]="'Open Workflows'">
        <app-components-managecustomer-open-workflows *tabContent
          [customerId]="customer.CustomerId"
          [partner]="partner"
          [user]="user">
        </app-components-managecustomer-open-workflows>
      </app-dynamic-tab>
    </app-tab-panel>
  </div>
</div>